export let projects = [
  
  {
    title: "MemeScore",
    description: "App that allows you to upload and view other humorous images and memes ",
    image: "https://i.imgur.com/o9zcOQS.png",
    repositoryLink: "https://github.com/Primemerlinian/memescore-front",
    deploymentLink: "https://memescore.netlify.app/",
    tech: "HTML5, CSS3, JavaScript, TypeScript, React",
  },
  {
    title: "PlanPro",
    description: "PlanPro offers a holistic view of an individual's work and personal life, eliminating the need for constant calendar switching. ",
    image: "https://i.imgur.com/0zkeWOm.png",
    repositoryLink: "https://github.com/Primemerlinian/PlanPro-front-end",
    deploymentLink: "https://planpro.netlify.app/",
    tech: "HTML5, CSS3, JavaScript, React",
  },
  {
    title: "AskMe Coffee",
    description:
      "The AskMe Coffee app stores your favorite coffee combinations and allows you to view your friend's drinks and possibly try them the next time you are in line for coffee.☕️",
    image: "https://i.imgur.com/FUJjW7J.png",
    repositoryLink: "https://github.com/Primemerlinian/AskMeCoffee.git",
    deploymentLink: "https://askmecoffee.fly.dev/",
    tech: "HTML5, CSS3, JavaScript, Express.js, Mongoose, MongoDB, EJS, Google OAuth.",
  },
  {
    title: "Beauty",
    description:
      "Your new favorite online pet! This simulator game allows you to play with your pet and enjoy her favorite activites when you click on the corresponding demand.",
    image: "https://i.imgur.com/SUzNdbn.png",
    repositoryLink: "https://github.com/Primemerlinian/Beauty",
    deploymentLink: "https://beauty-simulator.netlify.app/",
    tech: "HTML5, CSS3, JavaScript",
  },
  {
    title: "Connect4",
    description: "Online Connect4 game! ",
    image: "https://i.imgur.com/SUoEKYn.png",
    repositoryLink: "https://github.com/Primemerlinian/Connect4",
    deploymentLink: "https://mariah-lara-connect-4.netlify.app/",
    tech: "HTML5, CSS3, JavaScript",
  },
  {
    title: "Pixel-Toe",
    description: "Online pixelated Tic-Tac-Toe game!",
    image: "https://i.imgur.com/IGo3PGL.png",
    repositoryLink: "https://github.com/Primemerlinian/ttt-weekend.git",
    deploymentLink: "https://pixel-toe-mariah-lara.netlify.app/",
    tech: "HTML5, CSS3, JavaScript",
  },
];
